import Vue from 'vue';

const getDefaultClientState = () => ({
  logoUrls: [],
  placeholderLogoSrc: '/favicon-512x512.png',
});

export default {
  state: getDefaultClientState(),
  actions: {
    async GET_CLIENT_LOGOS_URL(context, payload) {
      const request = {
        url: '/api/v4/parent/clients/logo-urls',
        parameters: payload
      };
      const mutation = 'UPDATE_CLIENT_LOGOS_URL';
      const options = {
        request,
        mutation,
      };
      return await context.dispatch('MAKE_GET_REQUEST', options);
    },
  },

  mutations: {
    UPDATE_CLIENT_LOGOS_URL(state, payload) {
      state.logoUrls = payload;
    },
    RESET_CLIENT_STATE(state) {
      Object.assign(state, getDefaultClientState());
    },
  },

  getters: {
    logoUrls(state) {
      return state.logoUrls;
    },
    placeholderLogoSrc(state) {
      return state.placeholderLogoSrc;
    },
  },
};
